import useSWR from "swr";
import { websiteFetcher } from "../../../features/website/services/fetcher";

const useSelectOptionsWebsite = (endpoint, mapDataToOptions) => {
  const { data, error, isLoading } = useSWR(endpoint, websiteFetcher);

  let options = [];

  if (!isLoading && !error && data) {
    options = mapDataToOptions(data.results || data);
  }

  return {
    options,
    isLoading: !error && !data,
    error,
  };
};

export default useSelectOptionsWebsite;
